export default "__VITE_ASSET__7eeb3e1a__"